import * as DialogPrimitive from "@radix-ui/react-dialog";
import type { ComponentProps, HTMLAttributes } from "react";
import { cn } from "../lib/cn";

export const Dialog = DialogPrimitive.Root;
export const DialogTrigger = DialogPrimitive.Trigger;
export const DialogClose = DialogPrimitive.Close;

/**
 * A dialog (docs/design/meridian.md): `radius-dialog`, `shadow-overlay`, over the scrim. It enters with a 200 ms fade
 * and rise (none with reduced motion) and leaves at once.
 */
export function DialogContent({
  className,
  children,
  ...props
}: ComponentProps<typeof DialogPrimitive.Content>) {
  return (
    <DialogPrimitive.Portal>
      <DialogPrimitive.Overlay className="fixed inset-0 bg-scrim animate-[meridian-fade-in_var(--duration-base)_var(--ease-standard)]" />
      <DialogPrimitive.Content
        className={cn(
          "fixed top-1/2 left-1/2 flex max-h-[calc(100vh-4rem)] w-[calc(100vw-2rem)] max-w-lg -translate-x-1/2 -translate-y-1/2 flex-col gap-4 overflow-y-auto rounded-(--radius-dialog) bg-surface p-6 shadow-overlay animate-[meridian-dialog-in_var(--duration-base)_var(--ease-standard)]",
          className,
        )}
        {...props}
      >
        {children}
      </DialogPrimitive.Content>
    </DialogPrimitive.Portal>
  );
}

export function DialogTitle({ className, ...props }: ComponentProps<typeof DialogPrimitive.Title>) {
  return (
    <DialogPrimitive.Title className={cn("text-heading font-semibold text-ink", className)} {...props} />
  );
}

export function DialogDescription({
  className,
  ...props
}: ComponentProps<typeof DialogPrimitive.Description>) {
  return <DialogPrimitive.Description className={cn("text-small text-ink-muted", className)} {...props} />;
}

/** The dialog's actions, at its end: the primary last. */
export function DialogFooter({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("flex flex-wrap justify-end gap-2 pt-2", className)} {...props} />;
}
